import { TripDTO } from '../types/trip';
import { EVENT_MESSAGE_IDS } from './constants';
import { transformEventCode } from './transform-event-code';

export function prepareTripsList(trips: TripDTO[]): TripDTO[] {
  return trips
    .map((trip) => ({
      ...trip,
      events: (trip.messages || [])
        .filter((msg) => EVENT_MESSAGE_IDS.includes(msg.eventId))
        .map(transformEventCode),
    }))
    .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
}
